(($) => {
  Drupal.behaviors.magnific_popup = {
    attach: function (context, settings) {

      $('body:not(.page-node-type-front-page) .popup-youtube, body:not(.page-node-type-front-page) .popup-vimeo, body:not(.page-node-type-front-page) .popup-gmaps').magnificPopup({
        disableOn: 700,
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,

        fixedContentPos: false
      });

      $('body.page-node-type-front-page .popup-youtube, body.page-node-type-front-page .popup-vimeo, body.page-node-type-front-page .popup-gmaps').magnificPopup({
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,

        fixedContentPos: false
      });

    }
  };
})(jQuery);
